import {applyMiddleware, createStore} from 'redux';
import shareStore from './reducers';
import thunk from 'redux-thunk';

const middleware = [thunk];
const store = createStore(shareStore, {}, applyMiddleware(...middleware));

export default store;
